import React from 'react';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const isAdminLoggedIn = localStorage.getItem('isAdminLoggedIn') === 'true';

  if (!isAdminLoggedIn) {
    // 如果未登录，重定向到登录页面
    return <Navigate to="/login" replace />;
  }

  // 如果已登录，渲染子组件
  return <>{children}</>;
};

export default ProtectedRoute; 